import React, { type ImgHTMLAttributes } from "react";

export const LightspeedLogo = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      src="https://assets-upserve.s3.amazonaws.com/logos/lightspeed-logo.svg"
      className="logo-icon"
      alt="Lightspeed (U-Series)"
      {...props}
    />
  );
};
